var BlockView = require('views/block/base-block-view');
import IconLoadService from 'services/icon-load-service';

var IconView = BlockView.extend({
  className: 'icon',
  initialize: function () {
    const params = {
      'cid': this.model.cid,
      'uuid': this.model.cid
    }
    this.model.set(params);
    if (this.model.get('layer_icons')) {
      if (this.model.get('icons').length > 1) {
        IconLoadService.stackIcons(this.model.get('icons'), this.model.cid);
      }
    } else {
      const customClasses = [];
      customClasses.push(this.model.get('size'));
      customClasses.push(this.model.get('classes'));
      const icon = this.model.get('icon');

      if(icon) {
        IconLoadService.applyIcon(icon, this.model.cid, customClasses);
      } else {
        const iconPrefix = this.model.get('prefix') || null;
        
        if (iconPrefix !== null) {
          const iconName = this.model.get('name');
          IconLoadService.applyIcon(iconName, this.model.cid, customClasses, iconPrefix);
        }
      }
    }
    BlockView.prototype.initialize.apply(this, arguments);
  },
  play: function () {
    this.readyToGo();
  }
});

module.exports = IconView;
